import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { getCategoryMeta, SEVERITY_COLOR, formatNotifTime } from '../lib/notifications';
import { Activity } from 'lucide-react';

// Compact activity feed reused on both partner and admin dashboards.
const RecentActivity = ({ limit = 5 }) => {
  const { notifications, markRead } = useNotifications();
  const navigate = useNavigate();
  const items = notifications.slice(0, limit);

  const onClick = (notif) => {
    if (!notif.read) markRead(notif.id);
    if (notif.link) navigate(notif.link);
  };

  return (
    <Card className="bg-white border-[#E2E2DF]">
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base flex items-center gap-2">
          <Activity className="w-4 h-4 text-[#ef785b]" /> Recent Activity
        </CardTitle>
        <button onClick={() => navigate('/notifications')} className="text-xs text-[#ef785b] hover:underline">
          View all
        </button>
      </CardHeader>
      <CardContent className="p-0">
        {items.length === 0 ? (
          <p className="text-center text-[#64748B] text-sm py-6">No activity yet.</p>
        ) : (
          <div className="divide-y divide-[#F0F0EE]">
            {items.map((notif) => {
              const meta = getCategoryMeta(notif.category);
              const Icon = meta.icon;
              const tint = SEVERITY_COLOR[notif.severity] || meta.color;
              return (
                <button
                  key={notif.id}
                  onClick={() => onClick(notif)}
                  className={`w-full text-left flex items-start gap-3 px-4 py-3 hover:bg-[#FAFAF8] ${notif.read ? '' : 'bg-[#ef785b]/5'}`}
                >
                  <span className="mt-0.5 shrink-0 w-7 h-7 rounded-full flex items-center justify-center" style={{ backgroundColor: `${tint}1A` }}>
                    <Icon style={{ color: tint, width: 15, height: 15 }} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-[#1A1A1A] truncate">{notif.title}</p>
                    <p className="text-xs text-[#64748B] line-clamp-1">{notif.body}</p>
                  </div>
                  <span className="text-[10px] text-[#94A3B8] shrink-0 mt-0.5">{formatNotifTime(notif.created_at)}</span>
                </button>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentActivity;
